import { IIndirectTaxFilingV2ServiceRequestAssociation } from '@commenda/api/indirect-tax/filings/types';
import { TaskParty } from '@prisma/client';

import { IndirectTaxFilingActivityTable } from './activity/IndirectTaxFilingActivityTable';

interface IndirectTaxFilingDetailActivityProps {
  serviceRequest?: IIndirectTaxFilingV2ServiceRequestAssociation | null;
  role?: TaskParty;
}

const IndirectTaxFilingDetailActivity = ({
  serviceRequest,
  role = TaskParty.CLIENT,
}: IndirectTaxFilingDetailActivityProps) => {
  if (!serviceRequest?.id) {
    return (
      <div className="flex flex-col items-center justify-center gap-md py-20">
        <p className="txt-medium-bold text-text-primary">No activity yet.</p>
        <p className="txt-small-regular text-text-secondary">
          Activity will appear here once this filing is picked up by the
          Commenda team.
        </p>
      </div>
    );
  }

  return (
    <div className="p-3xl">
      <IndirectTaxFilingActivityTable
        serviceRequestId={serviceRequest.id}
        role={role}
      />
    </div>
  );
};

export { IndirectTaxFilingDetailActivity };
